import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Title = styled(Text)`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
